/* Dynamic Plot code copyright 2024 (c) Tuva Labs Inc.
 *
 * created by cmiller
 */

export class FilteredCasesDisplay {
    /** construct a filtered cases display for the TuvaJr home view.
     * see also PlotView.excludedCasesDisplay and PlotView.excludedCasesRect which this is based on. */
    constructor( Dyn, container, alignment ) {
        this.Dyn = Dyn;
        this.container = container;
        this.bounds = new Dyn.mathUtil.Rect(0,0,0,0); // display area within container.paper
        this.alignment = alignment; // "top-right" or "bottom"

        let paper = this.container.paper,
            fontSize = Dyn.preferences.getFontSize( Dyn.plotUtil.excludedCasesFontSize );
        this.numFilteredText = paper.text( 0, 0, "" )
            .attr({ "font-size":fontSize } )
            .hide();
        this.filterIcon = paper.path( Dyn.plotUtil.getFilterIcon( Dyn.plotUtil.fileredCaseIconSize ))
            .attr({stroke:"none", fill:"black" })
            .hide();
        this.coverRect = paper.rect( 0, 0, 0, 0 )
            .attr( Dyn.debugViewRects ?
                { fill: "none", stroke: "orange", opacity: 0.5 } : // make visible for debugging
                { fill: "gray", stroke: "none", opacity: 0.01 } )
            .data( "tooltip", "" )
            .data( "numFiltered", 0 )
            .hover( hoverIn, hoverOut )
            .hide();

        function hoverIn( event ) {
            // show "n case(s) missing" and/or "n case(s) filtered" tooltip
            // based on excludedCasesHoverOver()
            let missingCases = caseOrCases( this.data( "numMissing" ), false ),
                filteredCases = caseOrCases( this.data( "numFiltered" ), true ),
                txt = (missingCases ? missingCases + "\n" : "") + filteredCases;
            this.data( { "tooltip": txt } );
            Dyn.toolTip.show( this, event, {
                x: this.getBBox().x2, y: this.getBBox().y2 + 20
            } );

            function caseOrCases( number, isFilter ) {
                if( number > 0 ) {
                    if( isFilter ) {
                        return (number === 1) ? Dyn.loc( "1 case filtered" ) :
                            Dyn.loc( "{{n}} cases filtered", { n: number } );
                    } else {
                        return (number === 1) ? Dyn.loc( "1 case with missing values" ) :
                            Dyn.loc( "{{n}} cases with missing values", { n: number } );
                    }
                }
                return "";
            }
        }

        function hoverOut() {
            this.data( { "tooltip": "" } );
            if( Dyn.toolTip.isMyElement( this ) )
                Dyn.toolTip.hide();
        }
    }

    update( dataSet, parentBounds ) {
        let Dyn = this.Dyn,
            numFiltered = dataSet.caseFilter.numCasesFiltered;
        const isTopRight = this.alignment==="top-right"
        if( isTopRight ) {
            // start with our bounds at top of parent bounds
            this.bounds.removeDebugRect( this.container.paper );
            this.bounds = new Dyn.mathUtil.Rect( parentBounds );
            this.bounds.x = parentBounds.right();
            this.bounds.width = 0;
        } else {
            // start with our bounds at bottom of parent bounds
            this.bounds.removeDebugRect( this.container.paper );
            this.bounds = new Dyn.mathUtil.Rect( parentBounds );
            this.bounds.y = parentBounds.bottom();
        }

        // now add, update, or remove display
        if( numFiltered > 0 ) {
            // show filter display
            const yIcon = 2, // offset slightly to align with text
                fontSize = Dyn.preferences.getFontSize( Dyn.plotUtil.excludedCasesFontSize ),
                textOffset = fontSize - 0,
                iconOffset = isTopRight? Dyn.plotUtil.fileredCaseIconSize : 0;
            this.bounds.height = (isTopRight? 1:-1) * fontSize * 3;
            this.bounds.normalize();
            let x = isTopRight ? this.bounds.right() : this.bounds.centerX(),
                y = this.bounds.top() + fontSize;
            this.filterIcon.attr({ opacity: 1 })
                .transform( "t" + (x-iconOffset) + "," + (y+yIcon) )
                .show();
            this.numFilteredText.attr({
                text:"-"+numFiltered, x:x-textOffset-iconOffset, y:y, opacity:1, "text-anchor":"end", 'font-size':fontSize } )
                .show();
            let bbox = new Dyn.mathUtil.Rect( this.filterIcon.getBBox());
            bbox.union( new Dyn.mathUtil.Rect( this.numFilteredText.getBBox()));
            this.coverRect.attr({ x:bbox.x, y:bbox.y, width:bbox.width, height:bbox.height })
                .show();
            if( isTopRight ) {
                this.bounds.width = bbox.width;
                this.bounds.x = x - bbox.width
            }
        } else {
            // hide filter display
            this.bounds.height = 0;
            this.filterIcon.hide();
            this.numFilteredText.hide();
            this.coverRect.hide();
        }
        this.coverRect.data( "numFiltered", numFiltered );
        this.bounds.addDebugRect( this.container.paper );
        Dyn.assertValidRect( this.bounds );
        return this.bounds.height;
    }
}
